import { useMutation, useQueryClient } from "@tanstack/react-query";

import { markCarbonProgramDraftImplemented } from "services";

import { GET_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFTS, MARK_CARBON_PROGRAM_DRAFT_IMPLEMENTED } from "consts";

export const useMarkCarbonProgramDraftImplemented = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MARK_CARBON_PROGRAM_DRAFT_IMPLEMENTED],
    mutationFn: markCarbonProgramDraftImplemented,
    onSuccess: (draft) => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_DRAFTS] });
      queryClient.setQueryData([GET_CARBON_PROGRAM_DRAFT, draft.id], draft);
    },
  });
};
